module.exports = __webpack_public_path__ + "static/eric-96a86d50f90bc2a63d69ef42af1b08a8.jpg";